<template>
  <div class="vitamin-subcategory" :data-subcategoryid="subcategory.id">
    <h3>{{localizedField(subcategory,'Title')}}</h3>
    <p>{{localizedField(subcategory,'Information')}}</p>

    <!--    <ul class="pl-0 mb-0">-->
    <!--      <li class="mb-3">-->
    <!--        <p class="mb-1">{{subcategory.Title}} insight 1</p>-->
    <!--        <span class="small">-->
    <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
    <!--                                            Autem blanditiis pariatur quis repudiandae, veritatis voluptatum.-->
    <!--                                          </span>-->
    <!--      </li>-->
    <!--      <li class="mb-3">-->
    <!--        <p class="mb-1">{{subcategory.Title}} insight 2</p>-->
    <!--        <span class="small">-->
    <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
    <!--                                            Adipisci atque cum cumque, id nostrum sint!-->
    <!--                                          </span>-->
    <!--      </li>-->
    <!--      <li class="mb-3">-->
    <!--        <p class="mb-1">{{subcategory.Title}} insight 3</p>-->
    <!--        <span class="small">-->
    <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
    <!--                                            Beatae itaque modi placeat sint temporibus vel?-->
    <!--                                          </span>-->
    <!--      </li>-->
    <!--    </ul>-->
    <template v-if="reviewType === 'user'">
      <textarea :disabled="submission.reviewed || userRole === 'manager'" v-model="comment" name="" id="" cols="30"
                rows="5" class="styled-input form-control"></textarea>
      <button v-if="!submission.reviewed && userRole !== 'manager'" @click.prevent="saveComment($event)"
              class="d-block ml-auto btn btn-sm btn-primary">
        {{$t('message.save')}}
      </button>
    </template>
  </div>
</template>
<script>
  import store from "../../store/store";

  export default {
    data() {
      return {
        originalComment: null,
        comment: '',
        viewingUser: store.getters.getUser,
      }
    },
    mounted() {
      if (this.reviewType === 'user') {
        this.getComment()
      }
    },
    methods: {
      saveComment(e) {
        let btn = e.target;
        btn.classList.add('loading');
        let comment = {
          userid: this.submission.user,
          submissionid: this.submission.id,
          subcategoryid: this.subcategory.id,
          text: this.comment
        };
      //  console.log('saving comment', comment)

        if (this.originalComment) {
        //  console.log('editing')
          this.axios.put('/comments/' + this.originalComment.id, comment).then(r => {
            // btn.classList.remove('loading');
            this.loadingSuccess(btn)
          })
        } else {
      //    console.log('posting')
          this.axios.post('/comments', comment).then(r => {
            // btn.classList.remove('loading');
            this.loadingSuccess(btn)
          })
        }
      },
      getComment() {
        // console.log('getting comment');
        let q = '/comments?subcategoryid=' + this.subcategory.id + '&submissionid=' + this.submission.id;
        // console.log('q',q)
        this.axios.get(q).then(r => {
          // console.log('got commtn',r)
          if (r.data.length) {
            this.originalComment = r.data[0];
            this.comment = r.data[0].text
          }
        })
      }
    },
    props: {
      submission: {
        type: Object,
        default() {
          return null
        }
      },
      reviewType: {
        type: String,
        default() {
          return 'team'
        }
      },
      subcategory: {
        type: Object,
        default() {
          return null
        }
      }
    }
  }
</script>
<style>
  .vitamin-subcategory ul {
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Review/VitaminSubcategory.vue